import * as React from 'react';
import type { SVGProps } from 'react';
const SvgManipulation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M5 4h2V3L4 0 1 3v1h2v5h2zM13 4h2V3l-3-3-3 3v1h2v5h2zM0 14h16v2H0zM0 11h16v2H0z" />
  </svg>
);
export default SvgManipulation;
